import React from 'react';
import PropTypes from 'prop-types';

// Helpers
import { taskShape } from 'src/api/task';

// Components
import Icon from 'src/react/components/icon/Icon';
import useActionWithDisabled from 'src/react/helpers/useActionWithDisabled';

const completedTaskProps = {
  task: taskShape,
  onCompleteClick: PropTypes.func
};

const CompletedTask = (props) => {
  const { task, onCompleteClick } = props;
  const { isDisabled, wrapAction } = useActionWithDisabled();

  return (
    <div
      style={isDisabled ? { opacity: 0.1 } : {}}
      className="Recommendations-completedTask p-2 sm:p-4 mb-3 text-left rounded-lg"
    >
      <h2 className="font-semibold leading-none text-4 sm:text-6">
        {task.title}
      </h2>
      <button
        onClick={wrapAction(onCompleteClick, task)}
        className="text-green-40 text-3 flex items-center cursor-pointer"
        data-testid="completed_toggle_button"
        disabled={isDisabled}
      >
        <Icon name="check" className="mr-1" />
        Completed
      </button>
    </div>
  );
};
CompletedTask.propTypes = completedTaskProps;

export default CompletedTask;
